"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[677],{

/***/ 10677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l": function() { return /* binding */ FormLayout; }
});

// EXTERNAL MODULE: ./node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(86872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(20129);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/IconButton.js + 3 modules
var IconButton = __webpack_require__(61532);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/Button.js
var Button = __webpack_require__(25923);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Form/Form.js








var FormContext = /*#__PURE__*/ (0,react.createContext)({
    onSubmit: function() {},
    formId: ""
}), FormProvider = function(param) {
    var onSubmit = param.onSubmit, formId = param.formId, children = param.children;
    var backupId = (0,react.useId)(), id = formId || backupId;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(FormContext.Provider, {
        value: {
            onSubmit: onSubmit,
            formId: id
        },
        children: children
    });
}, FormComponent = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var ref = (0,react.useContext)(FormContext), onSubmit = ref.onSubmit, formId = ref.formId;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        tag: "form",
        id: formId,
        onSubmit: cjs.isWeb ? onSubmit : void 0
    }, props), {
        children: children
    }));
}, FormButton = function(props) {
    var ref = (0,react.useContext)(FormContext), onSubmit = ref.onSubmit, formId = ref.formId;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
        type: "submit",
        form: formId,
        onPress: cjs.isWeb ? void 0 : onSubmit
    }, props));
}, Form = (0,cjs.withStaticProperties)(FormProvider, {
    Form: FormComponent,
    Button: FormButton
});


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Keyboard/index.js
var Keyboard = __webpack_require__(33668);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/shared/useKeyboardIsVisible.js



var KEYBOARD_HEIGHT_THRESHOLD = 100, NON_KEYBOARD_INPUT_TYPES = /* @__PURE__ */ new Set([
    "button",
    "checkbox",
    "color",
    "file",
    "hidden",
    "image",
    "radio",
    "range",
    "reset",
    "submit"
]), isKeyboardTriggeringElementFocused = function() {
    var el = document.activeElement;
    return el ? (0,_instanceof/* default */.Z)(el, HTMLTextAreaElement) ? !0 : (0,_instanceof/* default */.Z)(el, HTMLInputElement) ? !NON_KEYBOARD_INPUT_TYPES.has(el.type) : el.isContentEditable === !0 : !1;
}, useIsKeyboardVisible = function() {
    var ref = (0,react.useState)(!1), isKeyboardVisible = ref[0], setKeyboardVisible = ref[1];
    return (0,react.useEffect)(function() {
        var didShow = Keyboard/* default.addListener */.Z.addListener("keyboardDidShow", function() {
            return setKeyboardVisible(!0);
        }), didHide = Keyboard/* default.addListener */.Z.addListener("keyboardDidHide", function() {
            return setKeyboardVisible(!1);
        });
        return function() {
            didShow.remove(), didHide.remove();
        };
    }, []), (0,react.useEffect)(function() {
        if ( true && window.visualViewport) {
            var baselineHeight = Math.max(document.documentElement.clientHeight, window.visualViewport.height);
            var resizeHandler = function() {
                if (window.visualViewport) {
                    var currentHeight = window.visualViewport.height, isFocused = isKeyboardTriggeringElementFocused();
                    isFocused ? baselineHeight = Math.max(baselineHeight, document.documentElement.clientHeight) : baselineHeight = Math.max(document.documentElement.clientHeight, currentHeight);
                    var heightDiff = baselineHeight - currentHeight;
                    setKeyboardVisible(heightDiff > KEYBOARD_HEIGHT_THRESHOLD && isFocused);
                }
            };
            return window.visualViewport.addEventListener("resize", resizeHandler), function() {
                var ref;
                return (ref = window.visualViewport) === null || ref === void 0 ? void 0 : ref.removeEventListener("resize", resizeHandler);
            };
        }
    }, []), isKeyboardVisible;
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/LayoutContext.js

var LayoutContext = /*#__PURE__*/ (0,react.createContext)({});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/LayoutGroup.js





var LayoutGroup = function(_param) /* @__PURE__ */ {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        group: "formLayout",
        flexDirection: "row",
        justifyContent: "center"
    }, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
            flexGrow: 1,
            width: "100%",
            children: children
        })
    }));
};


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Novo.js
var Novo = __webpack_require__(59895);
// EXTERNAL MODULE: ./node_modules/@tamagui/stacks/dist/esm/Stacks.mjs
var Stacks = __webpack_require__(43702);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/View/index.js
var View = __webpack_require__(67177);
;// CONCATENATED MODULE: ./node_modules/@tamagui/linear-gradient/dist/esm/linear-gradient.mjs




function LinearGradient({
  colors,
  locations,
  start,
  end,
  ...props
}) {
  const [{
      height,
      width
    }, setLayout] = react.useState({
      height: 1,
      width: 1
    }),
    linearGradientBackgroundImage = react.useMemo(() => getLinearGradientBackgroundImage(
    // @ts-expect-error ok
    colors, locations, start, end, width, height), [colors, locations, start, end, width, height]);
  return /* @__PURE__ */(0,jsx_runtime.jsx)(View/* default */.Z, {
    ...props,
    style: [props.style,
    // @ts-ignore: [ts] Property 'backgroundImage' does not exist on type 'ViewStyle'.
    {
      backgroundImage: linearGradientBackgroundImage
    }],
    onLayout: event => {
      const {
        width: width2,
        height: height2
      } = event.nativeEvent.layout;
      setLayout(oldLayout => width2 !== oldLayout.width || height2 !== oldLayout.height ? {
        height: height2,
        width: width2
      } : oldLayout), props.onLayout && props.onLayout(event);
    }
  });
}
function getLinearGradientBackgroundImage(colors, locations, startPoint, endPoint, width = 1, height = 1) {
  const gradientColors = calculateGradientColors(
  // @ts-expect-error TODO fix numbers
  colors, locations);
  return `linear-gradient(${calculatePseudoAngle(width, height, startPoint, endPoint)}deg, ${gradientColors.join(", ")})`;
}
function calculatePseudoAngle(width, height, startPoint, endPoint) {
  const getControlPoints = () => {
      let correctedStartPoint = [0, 0];
      Array.isArray(startPoint) && (correctedStartPoint = [startPoint[0] != null ? startPoint[0] : 0, startPoint[1] != null ? startPoint[1] : 0]);
      let correctedEndPoint = [0, 1];
      return Array.isArray(endPoint) && (correctedEndPoint = [endPoint[0] != null ? endPoint[0] : 0, endPoint[1] != null ? endPoint[1] : 1]), [correctedStartPoint, correctedEndPoint];
    },
    [start, end] = getControlPoints();
  start[0] *= width, end[0] *= width, start[1] *= height, end[1] *= height;
  const py = end[1] - start[1],
    px = end[0] - start[0];
  return 90 + Math.atan2(py, px) * 180 / Math.PI;
}
function calculateGradientColors(colors, locations) {
  return colors.map((color, index) => {
    const output = (0,cjs.normalizeColor)(color);
    if (locations && locations[index]) {
      const percentage = Math.max(0, Math.min(1, locations[index])) * 100;
      return `${output} ${percentage}%`;
    }
    return output;
  });
}

//# sourceMappingURL=linear-gradient.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tamagui/linear-gradient/dist/esm/LinearGradient.mjs




const LinearGradientFrame = (0,cjs.styled)(Stacks/* YStack */.FA, {
    name: "LinearGradient",
    overflow: "hidden",
    position: "relative"
  }),
  LinearGradient_LinearGradient = LinearGradientFrame.styleable((propsIn, ref) => {
    const props = (0,cjs.useProps)(propsIn),
      {
        start,
        end,
        colors: colorsProp,
        locations,
        children,
        ...stackProps
      } = props,
      theme = (0,cjs.useTheme)();
    let colors = props.colors?.map(c => theme[c]?.get("web") ?? c) || [];
    return  false && (0), /* @__PURE__ */(0,jsx_runtime.jsxs)(LinearGradientFrame, {
      ref,
      ...stackProps,
      children: [/* @__PURE__ */(0,jsx_runtime.jsx)(LinearGradient, {
        start,
        end,
        colors,
        locations,
        style: gradientStyle
      }), children]
    });
  }),
  gradientStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 0
  };

//# sourceMappingURL=LinearGradient.mjs.map

;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/LinearGradient.js








var gradientTokens = Novo/* Novo.gradient */.N.gradient, removeDollarSign = function(str) {
    return str.slice(1);
}, form_LinearGradient_LinearGradient = function(_param) {
    var gradient = _param.gradient, props = (0,_object_without_properties/* default */.Z)(_param, [
        "gradient"
    ]);
    var ref = (0,react.useMemo)(function() {
        var ref = gradientTokens[removeDollarSign(gradient)], colorStops = ref.colorStops, direction = ref.direction, sortedColorStops = (0,_to_consumable_array/* default */.Z)(colorStops).sort(function(cs1, cs2) {
            return cs1.stop - cs2.stop;
        }), colors2 = [], locations2 = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = sortedColorStops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var colorStop = _step.value;
                colors2.push(colorStop.color), locations2.push(colorStop.stop);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var start2 = {
            x: 0,
            y: 0
        }, radians = (parseInt(direction, 10) - 90) * (Math.PI / 180), end2 = {
            x: Math.round(Math.cos(radians) * 1e3) / 1e3,
            y: Math.round(Math.sin(radians) * 1e3) / 1e3
        };
        return end2.x < 0 && (start2.x = start2.x + 1, end2.x = end2.x + 1), end2.y < 0 && (start2.y = start2.y + 1, end2.y = end2.y + 1), {
            colors: colors2,
            locations: locations2,
            start: start2,
            end: end2
        };
    }, [
        gradient
    ]), colors = ref.colors, locations = ref.locations, start = ref.start, end = ref.end;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(LinearGradient_LinearGradient, (0,_object_spread/* default */.Z)({
        colors: colors,
        locations: locations,
        start: cjs.isWeb ? [
            start.x,
            start.y
        ] : start,
        end: cjs.isWeb ? [
            end.x,
            end.y
        ] : end
    }, props));
};


// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js + 66 modules
var Animated = __webpack_require__(13331);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(63988);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/ProgressBar.js






var formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, ProgressBar = function(param) {
    var completed = param.completed;
    var width = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0));
    return (0,react.useEffect)(function() {
        Animated/* default.timing */.Z.timing(width.current, {
            toValue: completed > 1 ? 1 : completed < 0 ? 0 : completed,
            // TODO: see if we can use tokens for animation values
            duration: 800,
            easing: Easing/* default.bezier */.Z.bezier(0.25, 0.1, 0.25, 1),
            useNativeDriver: !1
        }).start();
    }, [
        completed
    ]), /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        backgroundColor: formLayoutTokens.color.border.progressbar.incomplete,
        height: formLayoutTokens.progressBar.height,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Animated/* default.View */.Z.View, {
            style: {
                backgroundColor: (0,cjs.getTokenValue)(formLayoutTokens.color.border.progressbar.completed),
                height: "100%",
                width: width.current.interpolate({
                    inputRange: [
                        0,
                        1
                    ],
                    outputRange: [
                        "0%",
                        "100%"
                    ]
                })
            }
        })
    });
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/BottomNav.js













var BottomNav_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, BottomNav = function(_param) {
    var progressBarProps = _param.progressBarProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "progressBarProps"
    ]);
    var backButtonProps = "backButtonProps" in props ? props.backButtonProps : void 0, secondaryButtonProps = "secondaryButtonProps" in props ? props.secondaryButtonProps : void 0, submitButtonProps = "submitButtonProps" in props ? props.submitButtonProps : void 0, children = "children" in props ? props.children : void 0, _bottom = BottomNav_formLayoutTokens.margin.nav.bottom, topBottom = _bottom.topBottom, rightLeft = _bottom.rightLeft, setBottomNavHeight = (0,react.useContext)(LayoutContext).setBottomNavHeight, isKeyboardVisible = useIsKeyboardVisible();
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(LayoutGroup, {
        position: "absolute",
        pointerEvents: "none",
        bottom: 0,
        left: 0,
        right: 0,
        height: isKeyboardVisible ? 0 : void 0,
        opacity: isKeyboardVisible ? 0 : 1,
        animation: "accelerateDecelerateFastest",
        animateOnly: [
            "opacity"
        ],
        onLayout: function(param) {
            var _nativeEvent = param.nativeEvent, height = _nativeEvent.layout.height;
            setBottomNavHeight === null || setBottomNavHeight === void 0 ? void 0 : setBottomNavHeight(height);
        },
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(form_LinearGradient_LinearGradient, {
                height: BottomNav_formLayoutTokens.nav.bottom.scrim.height,
                gradient: BottomNav_formLayoutTokens.color.scrim
            }),
            progressBarProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(ProgressBar, (0,_object_spread/* default */.Z)({}, progressBarProps)),
            children || /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                pointerEvents: "auto",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: BottomNav_formLayoutTokens.color.background.nav.default,
                paddingVertical: topBottom.default,
                paddingHorizontal: rightLeft.xsmallviewport,
                "$group-formLayout-largerThanXS": {
                    paddingHorizontal: rightLeft.smallviewport
                },
                "$group-formLayout-largerThanSM": {
                    paddingHorizontal: rightLeft.mediumviewport
                },
                "$group-formLayout-largerThanMD": {
                    paddingHorizontal: rightLeft.largeviewport
                },
                "$group-formLayout-largerThanLG": {
                    paddingHorizontal: rightLeft.xlargeviewport
                },
                children: [
                    /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                        children: backButtonProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(IconButton/* ChevronBackButton */.jd, (0,_object_spread/* default */.Z)({
                            size: "medium",
                            "$group-formLayout-largerThanSM": {
                                frameSize: "large"
                            }
                        }, backButtonProps))
                    }),
                    /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
                        flexDirection: "row",
                        gap: BottomNav_formLayoutTokens.padding.nav.bottom.buttons,
                        children: [
                            secondaryButtonProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Button/* Button */.z, (0,_object_spread/* default */.Z)({
                                "data-testid": "formLayout-secondaryButton",
                                variant: "secondary",
                                size: "small",
                                "$group-formLayout-largerThanSM": {
                                    size: "large"
                                }
                            }, secondaryButtonProps)),
                            submitButtonProps && /* @__PURE__ */ (0,jsx_runtime.jsx)(Form.Button, (0,_object_spread/* default */.Z)({
                                variant: "primary",
                                size: "small",
                                "$group-formLayout-largerThanSM": {
                                    size: "large"
                                }
                            }, submitButtonProps))
                        ]
                    })
                ]
            })
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@tamagui/animate-presence/dist/esm/AnimatePresence.mjs + 3 modules
var AnimatePresence = __webpack_require__(26062);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/shared/InputLabelContext.js
var InputLabelContext = __webpack_require__(25689);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/FormContent.js










var FormContent_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, FormContent = function(_param) {
    var children = _param.children, animationKey = _param.animationKey, skipEnterAnimation = _param.skipEnterAnimation, skipExitAnimation = _param.skipExitAnimation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "animationKey",
        "skipEnterAnimation",
        "skipExitAnimation"
    ]);
    var _contentContainer = FormContent_formLayoutTokens.margin.contentContainer, top = _contentContainer.top, leftRight = _contentContainer.leftRight, mobileBetweenContainers = _contentContainer.mobileBetweenContainers, gap = _contentContainer.gap, inputId = (0,react.useContext)(InputLabelContext/* InputLabelContext */.F).inputId;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Form.Form, {
        flexGrow: 1,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            exitBeforeEnter: !0,
            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                animation: "decelerateFast",
                animateOnly: [
                    "opacity",
                    "transform"
                ],
                enterStyle: skipEnterAnimation ? void 0 : {
                    y: 40,
                    opacity: 0
                },
                exitStyle: skipExitAnimation ? void 0 : {
                    y: 0,
                    opacity: 0
                },
                flexGrow: 1,
                paddingTop: top.xsmallviewport,
                paddingHorizontal: leftRight.xsmallviewport,
                gap: mobileBetweenContainers,
                "$group-formLayout-largerThanXS": {
                    paddingTop: top.smallviewport,
                    paddingHorizontal: leftRight.smallviewport
                },
                "$group-formLayout-largerThanSM": {
                    paddingTop: top.mediumviewport,
                    paddingHorizontal: leftRight.mediumviewport,
                    flexDirection: "row",
                    gap: gap.mediumviewport
                },
                "$group-formLayout-largerThanMD": {
                    paddingTop: top.largeviewport,
                    paddingHorizontal: leftRight.largeviewport,
                    gap: gap.largeviewport
                },
                "$group-formLayout-largerThanLG": {
                    gap: gap.xlargeviewport
                }
            }, props), {
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(InputLabelContext/* InputLabelContext.Provider */.F.Provider, {
                    value: {
                        inputId: inputId
                    },
                    children: children
                })
            }), animationKey)
        })
    });
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/FormLayoutProvider.js








var FormLayoutProvider = function(_param) {
    var children = _param.children, singleQuestionInputId = _param.singleQuestionInputId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "singleQuestionInputId"
    ]);
    var ref = (0,react.useState)(), bottomNavHeight = ref[0], setBottomNavHeight = ref[1];
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Form, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(LayoutContext.Provider, {
            value: {
                bottomNavHeight: bottomNavHeight,
                setBottomNavHeight: setBottomNavHeight
            },
            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(InputLabelContext/* InputLabelContext.Provider */.F.Provider, {
                value: {
                    inputId: singleQuestionInputId
                },
                children: children
            })
        })
    }));
};


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/LegalCopy.js








var LegalCopy_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, LegalCopy = function(_param) /* @__PURE__ */ {
    var _links = _param.links, links = _links === void 0 ? [] : _links, props = (0,_object_without_properties/* default */.Z)(_param, [
        "links"
    ]);
    return (0,jsx_runtime.jsxs)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        tag: "small",
        typography: LegalCopy_formLayoutTokens.typography.legalText,
        color: LegalCopy_formLayoutTokens.color.content.legalText.default
    }, props), {
        children: [
            "\xa9 ",
            /* @__PURE__ */ new Date().getFullYear(),
            " Opendoor | Equal Housing Opportunity",
            links.length > 0 ? " | " : "",
            links.map(function(_param, idx) /* @__PURE__ */ {
                var text = _param.text, linkProps = (0,_object_without_properties/* default */.Z)(_param, [
                    "text"
                ]);
                return (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        /* @__PURE__ */ (0,jsx_runtime.jsx)(Link/* Link */.r, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: "secondary",
                            typography: LegalCopy_formLayoutTokens.typography.legalText,
                            color: LegalCopy_formLayoutTokens.color.content.legalText.default
                        }, linkProps), {
                            children: text
                        })),
                        idx === links.length - 1 ? "" : " \xb7 "
                    ]
                }, text);
            })
        ]
    }));
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/QuestionContainer.js



var QuestionContainer_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, QuestionContainer = function(param) {
    var children = param.children;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        gap: QuestionContainer_formLayoutTokens.padding.questions.betweenContent.xsmallviewport,
        "$group-formLayout-largerThanXS": {
            gap: QuestionContainer_formLayoutTokens.padding.questions.betweenContent.smallviewport
        },
        "$group-formLayout-largerThanSM": {
            gap: QuestionContainer_formLayoutTokens.padding.questions.betweenContent.mediumviewport,
            flexBasis: "50%",
            flexShrink: 1
        },
        "$group-formLayout-largerThanMD": {
            gap: QuestionContainer_formLayoutTokens.padding.questions.betweenContent.largeviewport
        },
        "$group-formLayout-largerThanLG": {
            gap: QuestionContainer_formLayoutTokens.padding.questions.betweenContent.xlargeviewport
        },
        children: children
    });
};


// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/index.js + 1 modules
var ScrollView = __webpack_require__(6765);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/ScrollContainer.js








var ScrollContainer_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, ScrollContainer = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children;
    var bottomNavHeight = (0,react.useContext)(LayoutContext).bottomNavHeight;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ScrollView/* default */.Z, {
        style: {
            height: cjs.isWeb ? "100dvh" : "100%"
        },
        contentContainerStyle: {
            flexGrow: 1
        },
        ref: ref,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(LayoutGroup, {
            flexGrow: 1,
            backgroundColor: ScrollContainer_formLayoutTokens.color.background.page.default,
            width: cjs.isWeb ? "100vw" : void 0,
            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                flexGrow: 1,
                backgroundColor: ScrollContainer_formLayoutTokens.color.background.layout.default,
                paddingBottom: bottomNavHeight,
                children: children
            })
        })
    });
});


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/Title.js






var Title_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, Title = function(param) {
    var tag = param.tag, title = param.title, fieldsRequired = param.fieldsRequired, subhead = param.subhead;
    var inputId = (0,react.useContext)(InputLabelContext/* InputLabelContext */.F).inputId;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
        gap: Title_formLayoutTokens.padding.questions.titleText.smallViewport,
        "$group-formLayout-largerThanSM": {
            gap: Title_formLayoutTokens.padding.questions.titleText.largeMediumViewport,
            flexBasis: "50%",
            flexShrink: 1
        },
        children: [
            /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                tag: inputId ? "label" : tag || "h1",
                htmlFor: inputId,
                color: Title_formLayoutTokens.color.content.singleQuestion.title,
                typography: Title_formLayoutTokens.typography.singleQuestion.title.smallViewport,
                "$group-formLayout-largerThanSM": {
                    typography: Title_formLayoutTokens.typography.singleQuestion.title.largeMediumViewports
                },
                children: title
            }),
            typeof fieldsRequired == "boolean" && /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                tag: "span",
                testID: "fieldsRequired",
                color: Title_formLayoutTokens.color.content.singleQuestion.supportText,
                typography: Title_formLayoutTokens.typography.singleQuestion.requirement.smallXsmallViewport,
                "$group-formLayout-largerThanSM": {
                    typography: Title_formLayoutTokens.typography.singleQuestion.requirement.largeMediumViewport
                },
                children: fieldsRequired ? "All fields are required" : "All fields are optional"
            }),
            typeof subhead == "string" ? /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                tag: "span",
                testID: "subhead",
                color: Title_formLayoutTokens.color.content.singleQuestion.supportText,
                typography: Title_formLayoutTokens.typography.singleQuestion.supportText.smallViewport,
                "$group-formLayout-largerThanSM": {
                    typography: Title_formLayoutTokens.typography.singleQuestion.supportText.largeMediumViewports
                },
                children: subhead
            }) : subhead
        ]
    });
};


// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Button/TextButton.js
var TextButton = __webpack_require__(52007);
;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/TopNav.js






var TopNav_formLayoutTokens = Components/* tokens.formLayout */.T.formLayout, TopNav = function(props) {
    var navLabel = "navLabel" in props ? props.navLabel : void 0, textButtonProps = "textButtonProps" in props ? props.textButtonProps : void 0, children = "children" in props ? props.children : void 0, _top = TopNav_formLayoutTokens.margin.nav.top, topBottom = _top.topBottom, rightLeft = _top.rightLeft;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
        paddingVertical: topBottom.xsmallviewport,
        paddingHorizontal: rightLeft.xsmallviewport,
        "$group-formLayout-largerThanXS": {
            paddingVertical: topBottom.smallviewport,
            paddingHorizontal: rightLeft.smallviewport
        },
        "$group-formLayout-largerThanSM": {
            paddingVertical: topBottom.mediumviewport,
            paddingHorizontal: rightLeft.mediumviewport
        },
        "$group-formLayout-largerThanMD": {
            paddingVertical: topBottom.largeviewport,
            paddingHorizontal: rightLeft.largeviewport
        },
        "$group-formLayout-largerThanLG": {
            paddingVertical: topBottom.xlargeviewport,
            paddingHorizontal: rightLeft.xlargeviewport
        },
        children: children || /* @__PURE__ */ (0,jsx_runtime.jsxs)(Box/* Box */.x, {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            children: [
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    children: navLabel && /* @__PURE__ */ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        tag: "span",
                        typography: TopNav_formLayoutTokens.typography.nav.top.address,
                        color: TopNav_formLayoutTokens.color.content.nav.top.addressLabel,
                        children: navLabel
                    })
                }),
                /* @__PURE__ */ (0,jsx_runtime.jsx)(Box/* Box */.x, {
                    children: (textButtonProps === null || textButtonProps === void 0 ? void 0 : textButtonProps.label) && /* @__PURE__ */ (0,jsx_runtime.jsx)(TextButton/* TextButton */.A, (0,_object_spread/* default */.Z)({
                        size: "small",
                        variant: "primary"
                    }, textButtonProps))
                })
            ]
        })
    });
};


;// CONCATENATED MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/layouts/form/index.js









var FormLayout = (0,cjs.withStaticProperties)(FormLayoutProvider, {
    BottomNav: BottomNav,
    FormContent: FormContent,
    LegalCopy: LegalCopy,
    QuestionContainer: QuestionContainer,
    ScrollContainer: ScrollContainer,
    Title: Title,
    TopNav: TopNav
});



/***/ })

}]);